<template>
  <div class="swiper-slide">
    <section class="tile">
      <template v-if="hints !== null">
        <transition name="hintbg" mode="out-in">
          <div v-if="hintVisible" class="hint-bg"></div>
        </transition>
        <transition name="hint" mode="out-in">
          <section v-if="hintVisible" class="hint" :class="{ 'active' : hintVisible }">
            <main>
              <header>
                <img :src="getImgUrl(iconId)" :alt="heading" />
                <h4>{{heading}}</h4>
              </header>
              <ul>
                <li v-for="hint in hints" :key="hint.sentence">
                  {{ hint.sentence }}
                </li>
              </ul>
            </main>
            <footer>
              <span class="close-hint swiper-no-swiping" @click="toggleHint()"></span>
            </footer>
          </section>
        </transition>
      </template>
      <header class="tile-header">
        <img rel="prefetch" :src="getImgUrl(iconId)" :alt="heading" /><h3>{{heading}}</h3>
        <template v-if="hints !== null">
          <span class="question swiper-no-swiping" :class="{ 'active' : hintVisible }" @click="toggleHint()">?</span>
        </template>
      </header>
      <main class="tile-main">
        <ul>
          <li v-for="content in contents" :key="content.sentence">
            {{ content.sentence }}
          </li>
        </ul>
      </main>
      <footer class="tile-footer">
        <checkbox v-if="input === 'checkbox'" :item-id="checkboxId" :item-disabled="inputDisabled" :label="label" :labelActive="labelActive" />
        <rangeslider v-if="input === 'rangeslider'" :item-id="checkboxId" :min="rangeMin" :max="rangeMax" :step="step" :label="rangeLabel" :item-disabled="inputDisabled" :single="singleRangeslider" />
      </footer>
    </section>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue'
import Rangeslider from '@/components/Rangeslider.vue'

export default {
  name: 'Tile',
  props: {
    label: {
      type: String,
      default: 'hinzufügen',
      required: false
    },
    labelActive: {
      type: String,
      default: 'hinzugefügt',
      required: false
    },
    step: {
      type: Number,
      default: 1
    },
    checkboxId: {
      type: String,
      required: true
    },
    tileclass: {
      type: String,
      default: '',
      required: false
    },
    heading: {
      type: String,
      default: '',
      required: false
    },
    contents: {
      type: Array,
      required: false
    },
    hints: {
      type: Array,
      default: null,
      required: false
    },
    iconId: {
      type: String,
      default: 'placeholder',
      required: false
    },
    input: {
      type: String
    },
    rangeMin: Number,
    rangeMax: Number,
    rangeStart: Number,
    rangeLabel: String,
    inputDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    singleRangeslider: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      hintVisible: false
    }
  },
  components: {
    Checkbox,
    Rangeslider
  },
  methods: {
    getImgUrl (icon) {
      var images = require.context('../assets/img/icons/items/', false, /\.svg$/)
      return images('./' + icon + '.svg')
    },
    toggleHint () {
      this.hintVisible = !this.hintVisible
    }
  }
}

</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";

.tile {
  width:100%;
  background: #fff;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  position: relative;
  .hint {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    height: 100%;
    width: 100%;
    background-color: none;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    main {
      overflow: auto;
      overflow-x:hidden;
      overflow-y:auto;
      -webkit-overflow-scrolling: touch;
      header {
        padding: 30px 20px 25px 20px;
        width: 100%;
        display: flex;
        align-items: center;
        h4 {
          font-family: $primaryFont;
          font-weight: $primaryFontBold;
          color: #fff;
          font-size: 16px;
          margin: 0;
          line-height: 1.1;
          /* padding: 30px 20px 15px 40px; */
        }
        img {
          border-radius: 6px;
          width: 26px;
          height: auto;
          margin-right: 8px;
        }
      }
      ul {
        margin: 0;
        padding: 0px 25px 80px 40px;
        li {
          color: #fff;
          list-style: none;
          position: relative;
          font-size: 16px;
          margin-bottom: 4px;
        }
        li:before {
          content:'';
          display:inline-block;
          background-position:center center;
          background-repeat:no-repeat;
          margin-right:8px;
          position: absolute;
          top: 6px;
          left: -20px;
          width: 14px;
          height: 14px;
          background-image: url('../assets/img/icons/listCheckWhite.svg');
        }
      }
    }
    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      .close-hint {
        background: $primaryColor;
        font-family: $secondaryFont;
        font-weight: $secondaryFontBold;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 20px;
        -webkit-box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
        -moz-box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
        background-image:url('../assets/img/icons/buttons/close.svg');
        background-position:center center;
        background-repeat:no-repeat;
        background-size: 15px 15px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .hint.active .close-hint {
    opacity: 0;
    animation-name: close-hint;
    animation-delay: 0.4s;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
    animation-direction: normal;
  }
  .hint-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 12px;
    display: block;
    background-color: #575757;
    content: '';
    z-index: 2;
    width: 100%;
    height: 100%;
  }
  header.tile-header {
    background: #fafafa;
    padding: 15px 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      border-radius: 6px;
      width: 34px;
      min-height: 34px;
      height: auto;
      margin-right: 8px;
      display: block;
    }
    h3 {
      font-size: 18px;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      color: $primaryFontColor;
      line-height: 1.1;
      margin: 0;
      hyphens: auto;
      width: 100%;
    }
    .question {
      background: #d9d9d9;
      color: #fafafa;
      line-height: 1;
      font-size: 17px;
      padding: 4px 9px;
      border-radius: 24px;
      font-family: $secondaryFont;
      font-weight: $secondaryFontBold;
      position: relative;
      transition: 0.2s ease-in-out;
    }
    .question:hover {
      cursor: pointer;
    }
  }
  main.tile-main {
    padding: 20px 20px;
    font-family: $secondaryFont;
    font-weight: $secondaryFontNormal;
    color: $secondaryFontColor;
    width: 100%;
    min-height: 100px;
    margin-bottom: 70px;
    ul {
      margin: 0;
      padding: 0 0 0 20px;
      li {
        list-style: none;
        position: relative;
        font-size: 16px;
        margin-bottom: 4px;
      }
      li:before {
        content:'';
        display:inline-block;
        background-position:center center;
        background-repeat:no-repeat;
        margin-right:8px;
        position: absolute;
        top: 6px;
        left: -20px;
        width: 14px;
        height: 14px;
        background-image: url('../assets/img/icons/listCheck.svg');
      }
    }
  }
  footer.tile-footer {
    padding: 0 20px;
    border-top: 2px solid #F2F2F2;
    width: 100%;
    height: 70px;
    position: absolute;
    bottom: 0;
    display: flex;
    align-content: center;
    align-items: center;
  }
}
@media(min-width:767px) {
  section.tile {
    header.tile-header {
      h3 {
        font-size: 18px;
      }
    }
  }
}
@media(min-width:1180px) {
  section.tile {
    header.tile-header {
      padding: 20px 20px;
    }
  }
}
.hint-enter-active {
  animation: hint-in .2s;
}
.hint-leave-active {
  animation: hint-out .02s;
}
.hintbg-enter-active {
  animation: hint-bg .1s;
}
.hintbg-leave-active {
  animation: hint-bg .1s reverse;
}
.hintbg-leave-active {
  animation: hint-bg-out .1s;
}
@keyframes hint-in {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0;
    transform: scale(1);
  }
  85% {
    transform: scale(1.02);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes hint-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes hint-bg {
  0% {
    left: 50%;
    bottom: 0;
    transform: translate(0, -50%);
    border-radius: 100px;
    width: 0;
    height: 0;
  }
  100% {
    left: 0;
    bottom: 0;
    border-radius: 12px;
    transform: translate(0%, 0%);
    width: 100%;
    height: 100%;
  }
}
@keyframes hint-bg-out {
  0% {
    left: 0;
    bottom: 0;
    border-radius: 12px;
    transform: translate(0, 0);
    width: 100%;
    height: 100%;
  }
  100% {
    left: 50%;
    bottom: 30px;
    transform: translate(0, 0);
    border-radius: 100px;
    width: 0;
    height: 0;
  }
}
@keyframes close-hint {
  0% {
    transform: translateX(-50%) scale(0);
    opacity: 0;
  }
  50% {
    transform: translateX(-50%) scale(1.02);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
}
</style>
